import React, { Component, useState, useEffect } from "react";
import { Button, Row, Col } from "react-materialize";
import config from "../../config";
import API from "../../utils/API";
import Html from "../../utils/Html";
import Func from "../../utils/Func";
import FormFunc from "../../utils/FormFunc";
import Feature from "../../utils/Feature";

import $ from "jquery";
import RecipTable from "./notification/RecipTable";
import RecipModalRemove from "./notification/RecipModalRemove";
import RecipFormAdd from "./notification/RecipFormAdd";
import { useInfo } from "context/InfoContext";

export default function Notification({ userData, handleEvents }) {
  const boxName = "content-usergroups";
  const { filters, filterData, storeFilters } = useInfo();
  const [isOpenForm, setOpenForm] = useState(false);
  const [isOpenRemove, setOpenRemove] = useState(false);
  const [removeItem, setRemoveItem] = useState({
    data: {},
    status: "",
    err: 0,
    err_msg: "",
  });
  handleEvents.BtnOpenForm = {
    OnClick: function (evt) {
      setOpenForm(!isOpenForm);
    },
  };
  handleEvents.BtnOpenRemove = {
    OnClick: function (evt) {
      setOpenRemove(!isOpenRemove);
    },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setOpenRemove(false);
    },
  };
  handleEvents.RemoveItems = {
    OnChange: function (evt) {
      const id = evt.target.value;
      const index = evt.target.getAttribute("data-index");
      const temp = [...filters.user_recips];
      let checkedAll = false;
      let checkedRemoveCount = 0;
      if (evt.target.checked) {
        if (id === "all") {
          for (const i in temp) {
            temp[i].checkedRemove = true;
            checkedRemoveCount += 1;
          }
          checkedAll = true;
        } else {
          temp[index].checkedRemove = true;
          checkedAll = true;
          for (const i in temp) {
            const checkedRemove = temp[i]?.checkedRemove ?? false;
            if (!checkedRemove) {
              checkedAll = false;
            } else {
              checkedRemoveCount += 1;
            }
          }
        }
      } else {
        if (id === "all") {
          for (const i in temp) {
            temp[i].checkedRemove = false;
          }
          checkedAll = false;
        } else {
          temp[index].checkedRemove = false;
        }
      }
      storeFilters({
        ...filters,
        user_recips: temp,
        checkedAllRemove: checkedAll,
        checkedRemoveCount: checkedRemoveCount,
      });
    },
    OnSubmit: function (evt) {
      setRemoveItem({ status: "inprocess" });
      const removeData = [];
      for (const i in filters.user_recips) {
        if (filters.user_recips[i]?.checkedRemove) {
          removeData.push(filters.user_recips[i].id);
        }
      }
      // console.log("removeData=>", removeData); //return;
      if (removeData.length === 0) {
        setRemoveItem({ data: "", status: "", err: 1, err_msg: "No Data" });
        return;
      }
      const mainFunc = async () =>
        await API.post("info/user/notification/remove", {
          params: ({
            removeData: removeData,
            userID: window.$user_profile.idu,
            staffID: filters?.idu ?? 0,
            staffEmail: filters?.email ?? "",
          }),
        });
      mainFunc()
        .then((res) => {
          setRemoveItem({ data: "", status: "", err: 0, err_msg: 0 });
          const decrypt = (res?.data);
          // console.log("alluser export=", decrypt);
          if (decrypt?.status === "success") {
            if (decrypt?.data) {
              storeFilters({
                ...filters,
                user_recips: decrypt.data,
                checkedAllRemove: false,
                checkedRemoveCount: 0,
                key_form: Func.GetKeyRandom(),
              });
            }
            $("body").css({ overflow: "auto" });
            setOpenRemove(false);
          } else {
            setRemoveItem({
              data: "",
              status: "",
              err: 1,
              err_msg: decrypt?.err_msg ?? "",
            });
          }
        })
        .catch((err) => {
          //console.log(infos.tabActive, err)
          setRemoveItem({ data: "", status: "", err: 1, err_msg: err });
          //storeFilterData({ err: 1, err_msg: `Failes : ${err}` });
        });
    },
  };
  useEffect(() => {}, []);
  // console.log("checkedRemoveCount=" + filters.checkedRemoveCount);
  return (
    <div id="noti-box" className="" style={{ margin: "0 20px" }}>
      <div className={boxName + " row"}>
        <span
          className="col s8"
          style={{ fontSize: "18px", fontWeight: "bold" }}
        >
          Email Notification Settings for user
        </span>
        <Button
          className="red accent-2"
          id="btn-remove-recip"
          node="button"
          waves="light"
          small={true}
          style={{
            float: "right",
            width: "80px",
            marginLeft: "12px",
            borderRadius: "20px",
            display: filters?.checkedRemoveCount > 0 ? "" : "none",
          }}
          onClick={handleEvents.BtnOpenRemove.OnClick}
        >
          REMOVE
        </Button>
        <Button
          className=""
          id="btn-open-form-recip"
          node="button"
          waves="light"
          small={true}
          style={{ float: "right", width: "80px", borderRadius: "20px" }}
          onClick={handleEvents.BtnOpenForm.OnClick}
        >
          ADD
        </Button>
      </div>
      {isOpenForm ? <RecipFormAdd handleEvents={handleEvents} /> : ""}
      <Row style={{ padding: "10px 5px" }}>
        <Col s={12}>
          {filters?.fname + " " + filters?.lname + " (" + filters?.email + ")"}
        </Col>
        <Col s={12} style={{ marginTop: "12px" }}>
          <span style={{ fontWeight: "bold", marginRight: "10px" }}>IDU</span>
          <a href={"/employees/profile?tab=employeeinfo&id=" + filters?.idu}>
            {filters?.idu}
          </a>
        </Col>
      </Row>
      <RecipTable
        userData={userData}
        data={filters?.user_recips ? filters.user_recips : []}
        handleEvents={handleEvents.RemoveItems}
      />
      <RecipModalRemove
        data={{
          isOpen: isOpenRemove,
          itemData: removeItem,
        }}
        setData={{
          setOpenRemove: setOpenRemove,
        }}
        handleEvents={handleEvents}
      />
    </div>
  );
}

